import {PostApi155, PostApi999} from "../../../modules/network/padoPost";
import {
    AppContext,
    LOG_IN_SUCCESS,
    LOG_OUT_SUCCESS,
    MAIN_MENU_ALL_SET,
    SELFCAED_MENU_ALL_SET,
    SocketCommand,
    socketManager
} from "../../../components/AppProvider";
import {
  allDelCookies,
  getCookie,
  getCookies,
  isLogin,
} from "../../../modules/utils/cookie";
import { openLayerFn } from "../../Layout";
import { useContext } from "react";
import { loginLogInterface } from "../../Membership/LoginOld";

export const autoLogin = (
  phonecfg,
  cfg,
  param,
  dispatch,
  setUserHlthInfo,
  request1910,
  request1913
) => {
  // let userinfo2;

  PostApi155(phonecfg, cfg, param)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
        if (res.resultList[0].result === "1") {
          dispatch({ type: LOG_IN_SUCCESS, data: res.resultList[0] });
          loginLogInterface(
            res.resultList[0],
            phonecfg,
            cfg,
            "I",
            "A",
            res.resultList[0].signUpChannel
          );
          socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            login: "in",
            userToken: res.resultList[0].userToken.toString(),
          });

          if (request1913) {
            request1913(res.resultList[0]);
          }
        } else if (res.resultMsg === "LOGOUT") {
          openLayerFn($(".alert-layer-logout"));
        } else {
          dispatch({ type: LOG_OUT_SUCCESS });
          allDelCookies();
          socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            login: "out",
            userToken: "",
          });
        }
      } else {
        openLayerFn($(".alert-layer-logout"));
      }
    })
    .catch(err => {
      console.log(err);
      openLayerFn($(".alert-layer-cnntFail"));
    });
};

export const reLogin = (auth, userinfo, dispatch) => {
  const { phonecfg, cfg } = useContext(AppContext);
  let userinfo2 = userinfo;

  if (getCookie("phoneToken") && !auth && isLogin()) {
    userinfo2 = getCookies([
      "userToken",
      "userName",
      "userEmail",
      "userPhone",
      "sex",
      "birth",
    ]);
    dispatch({ type: LOG_IN_SUCCESS, data: userinfo2 }); // 최근 진료교육자료
    let main = getCookie("main");
    dispatch({ type: MAIN_MENU_ALL_SET, data: main }); // main
    let selfcard = getCookie("selfcard");
    dispatch({ type: SELFCAED_MENU_ALL_SET, data: selfcard }); // selfcard
  }
  return userinfo2;
};

export const dupLogin = (phonecfg, cfg, userToken, dispatch) => {
  let returnValue;
  PostApi999(phonecfg, cfg, userToken)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
        if (res.resultList === 1) {
          return true;
        } else {
          openLayerFn($(".alert-layer-logout"));
          return false;
        }
      }
    })
    .catch(err => {
      console.log("### err :: ", err);
    });
};